module.exports = __webpack_public_path__ + "img/reflect-sky.c2bdd31.jpg";